import { kichCoSearchColumns, mauSacSearchColumns, quocGiaSearchColumns } from '../../../cols-definition';
import { FormFieldActions, FormFieldState } from '../../../hooks';
import { FormField, SearchField } from '@/components/custom/erp';
import type { Color, KichCo, QuocGia } from '@/types/schemas';
import { QUERY_KEYS } from '@/constants/query-keys';
import { Label } from '@/components/ui/label';

interface Props {
  formMode: 'add' | 'edit' | 'view';
  state: FormFieldState;
  actions: FormFieldActions;
}

export const AttributeTab = ({ formMode, state, actions }: Props) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='flex items-center gap-x-1'>
        <Label className='mt-3 min-w-36 font-medium'>Thể tích</Label>
        <FormField className='flex items-center gap-x-1' name='the_tich' type='number' disabled={formMode === 'view'} />
      </div>

      <div className='flex items-center gap-x-1'>
        <Label className='mt-3 min-w-36 font-medium'>Khối lượng</Label>
        <FormField
          className='flex items-center gap-x-1'
          name='khoi_luong'
          type='number'
          disabled={formMode === 'view'}
        />
      </div>

      <div className='flex items-center gap-x-1'>
        <Label className='mt-3 min-w-36 font-medium'>Nước sản xuất</Label>
        <SearchField<QuocGia>
          displayRelatedField='ten_qg'
          columnDisplay='ma_qg'
          disabled={formMode === 'view'}
          searchEndpoint={`/${QUERY_KEYS.QUOC_GIA}`}
          searchColumns={quocGiaSearchColumns}
          dialogTitle='Danh mục quốc gia'
          value={state.nuocSX?.ma_qg || ''}
          relatedFieldValue={state.nuocSX?.ten_qg || ''}
          onRowSelection={actions.setnuocSX}
          className='w-100'
        />
      </div>

      <div className='flex items-center gap-x-1'>
        <Label className='mt-3 min-w-36 font-medium'>Màu sắc</Label>
        <SearchField<Color>
          displayRelatedField='ten_mau_sac'
          columnDisplay='ma_mau_sac'
          disabled={formMode === 'view'}
          searchEndpoint={`/${QUERY_KEYS.MAU_SAC}`}
          searchColumns={mauSacSearchColumns}
          dialogTitle='Danh mục màu sắc'
          value={state.mauSac?.ma_mau_sac || ''}
          relatedFieldValue={state.mauSac?.ten_mau_sac || ''}
          onRowSelection={actions.setmauSac}
          className='w-100'
        />
      </div>

      <div className='flex items-center gap-x-1'>
        <Label className='mt-3 min-w-36 font-medium'>Kích cỡ</Label>
        <SearchField<KichCo>
          displayRelatedField='ten_kich_co'
          columnDisplay='ma_kich_co'
          disabled={formMode === 'view'}
          searchEndpoint={`/${QUERY_KEYS.KICH_CO}`}
          searchColumns={kichCoSearchColumns}
          dialogTitle='Danh mục kích cỡ'
          value={state.kichCo?.ma_kich_co || ''}
          relatedFieldValue={state.kichCo?.ten_kich_co || ''}
          onRowSelection={actions.setkichCo}
          className='w-100'
        />
      </div>
    </div>
  );
};
